module.exports = __webpack_public_path__ + "img/e596c982ade141128fca7a3b96aee8e5-640.868e1225.jpg";